import  {useState} from "react";
import { Input } from 'reactstrap';


function Integer(props) {
    let [value,updateValue] = useState(props.value);
    let className = '';

    const handleChange = element => {
        const value = element.target.value.replace(/[^0-9]/g,''); 
        updateValue(value);
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }
    return (
        <div>
            <Input
                id={'id_'+props.name}
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                maxLength={props.maxLength?props.maxLength:20}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span 
                    className="error invalid-feedback" 
                    style={{display:'inline'}}>
                        {props.error}
                </span>
            )}
        </div>
    );
}
export default Integer;
